// eslint-disable-next-line no-shadow
export enum DownloadStatus {
	PENDING = 'pending',
	SUCCESS = 'success',
	ERROR = 'error',
}
